// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import store from './store';

/* font awesome stuff */
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimesCircle, faArrowsAlt, faCog, faSun, faList, faExpandArrowsAlt, faCheck, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';
import 'vue-form-generator/dist/vfg.css';
import 'vue-form-generator/dist/vfg-core.css';

library.add(faTimesCircle, faArrowsAlt, faCog, faSun, faList, faExpandArrowsAlt, faCheck, faBan);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/docs.js